<template>
  <div class="pager_buttons">
    <a
      v-show="page > 1"
      @click="reportPreviousPage()"
      class="kp-button kp-button__min btn-blue">
      <i class="kp-panel-left" aria-hidden="true"></i>
    </a>
    <a
      v-show="!list.is_last_page"
      @click="reportNextPage()"
      class="kp-button kp-button__min btn-blue pull-right">
      <i class="kp-panel-right" aria-hidden="true"></i>
    </a>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  methods: mapActions([
    'reportNextPage',
    'reportPreviousPage',
  ]),
  computed: mapGetters({
    list: 'reportList',
    page: 'reportPage',
  }),
};
</script>




/** WEBPACK FOOTER **
 ** PaginationButtons.vue?7faa8532
 **/